import useSWR, { SWRResponse } from 'swr';
import {
  CreateShareLinkParams,
  CreateShareLinkResult,
  createShareLink,
} from '@/api/share-link';

type UseShareLinkParams = CreateShareLinkParams;

export function useShareLink({
  locationHref,
  onlyWeb,
  contentType,
  contentId,
  userId,
}: UseShareLinkParams): SWRResponse<CreateShareLinkResult, Error> {
  const key = [
    'share-link',
    locationHref,
    onlyWeb,
    contentType,
    contentId,
    userId,
  ];

  return useSWR<CreateShareLinkResult, Error>(
    key,
    async () => {
      const result = await createShareLink({
        locationHref,
        onlyWeb,
        contentType,
        contentId,
        userId,
      });
      return result;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 30000, // 30초 동안 중복 요청 방지
    },
  );
}
